import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ProductStoreState {
    user: {
        id: string;
        email?: string;
        fullName?: string;
        avatarUrl?: string;
        preferences?: Record<string, any>;
    } | null;
    tenant: {
        id: string;
        name?: string;
        role?: string;
        plan?: string;
    } | null;
    subscription: {
        plan_id: string;
        status: string;
        current_period_end?: string;
        plan_details?: any;
      } | null;
    credits: number;
    isLoading: boolean;
    error: Error | null;
}

interface ProductStore extends ProductStoreState {
    setProductMeta: (meta: ProductStoreState) => void;
}

export const useProductStore = create<ProductStore>()(
    persist(
        (set) => ({
            user: null,
            tenant: null,
            subscription: null,
            credits: 0,
            isLoading: false,
            error: null,
            setProductMeta: (meta) => set((state) => ({ ...state, ...meta })),
        }),
        {
            name: 'product-store',
            partialize: (state) => ({
                user: state.user,
                tenant: state.tenant,
                subscription: state.subscription,
                credits: state.credits,
            }),
        }

    )
);
